import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/product/list',
    pathMatch: 'full',
  },
  {
    path: 'profile',
    title: 'Thumb Zone | Profile',
    loadComponent: () => import('./profile/profile.component').then((c) => c.ProfileComponent),
  },
  {
    path: 'workspace',
    title: 'Thumb Zone | Workspace',
    loadComponent: () =>
      import('./edit-workspace/edit-workspace.component').then((c) => c.EditWorkspaceComponent),
  },
  {
    path: 'plans',
    title: 'Thumb Zone | Plans',
    loadComponent: () => import('./plans/plans.component').then((c) => c.PlansComponent),
  },
  {
    path: 'payment',
    title: 'Thumb Zone | Payment Status',
    loadComponent: () =>
      import('./payment-status/payment-status.component').then((c) => c.PaymentStatusComponent),
  },
  {
    path: 'invoices',
    title: 'Thumb Zone | Invoices',
    loadComponent: () => import('./invoices/invoices.component').then((c) => c.InvoicesComponent),
  },
  {
    path: 'product',
    children: [
      {
        path: 'list',
        title: 'Thumb Zone | Products',
        loadComponent: () =>
          import('./workspace/product/product-list/product-list.component').then(
            (c) => c.ProductListComponent,
          ),
      },
      {
        path: 'add',
        title: 'Thumb Zone | Add Product',
        loadComponent: () =>
          import('./workspace/product/product-add/product-add.component').then(
            (c) => c.ProductAddComponent,
          ),
      },
    ],
  },
  {
    path: 'tester',
    children: [
      {
        path: 'list',
        title: 'Thumb Zone | Testers',
        loadComponent: () =>
          import('./workspace/tester/tester-list/tester-list.component').then(
            (c) => c.TesterListComponent,
          ),
      },
    ],
  },
  //   {
  //     path: 'oauth/verify/:token',
  //     loadChildren: () =>
  //       import('./pages/authentication/oauth/oauth.module').then((m) => m.OauthModule),
  //   },
];
